import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { BookOpen } from "lucide-react";
import { goToCheckout } from "@/lib/checkout";
import { trackInitiateCheckout } from "@/lib/analytics";

export default function StickyMobileCTA() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 600);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleClick = () => {
    trackInitiateCheckout("sticky-mobile-cta");
    setTimeout(() => goToCheckout(), 120);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="sticky-mobile-cta"
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="lg:hidden fixed bottom-0 inset-x-0 z-40 px-3 pb-3 pt-2 bg-gradient-to-t from-[#FDFBF7] via-[#FDFBF7]/95 to-[#FDFBF7]/0"
        >
          <div className="rounded-full bg-white border border-[#E6E2D6] shadow-[0_18px_45px_rgba(42,48,42,0.18)] flex items-center pl-4 pr-1.5 py-1.5 gap-2">
            <div className="flex-1 min-w-0">
              <div className="text-[10px] tracking-wider uppercase text-[#849983] font-semibold">
                Oferta de lanzamiento
              </div>
              <div className="text-[12px] font-medium text-[#2A302A] truncate">
                Ebook + 4 bonos · USD 9.90
              </div>
            </div>
            <button
              data-testid="sticky-mobile-cta-button"
              onClick={handleClick}
              className="inline-flex items-center gap-1.5 bg-[#849983] hover:bg-[#6F856E] text-white rounded-full px-4 py-3 text-[11px] font-semibold tracking-wider shadow-[0_8px_20px_rgba(132,153,131,0.4)] whitespace-nowrap"
            >
              <BookOpen className="h-3.5 w-3.5" />
              QUIERO EMPEZAR AHORA
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
